"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _clamp = _interopRequireDefault(require("lodash/clamp"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
var _constants = require("../../constants");
var _objects = require("../objects");
var _context, _context2, _context3, _context4;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "popout-module__container___Q_LoY",
  "stickout": "popout-module__stickout___ahW1B",
  "content": "popout-module__content___MP8uI",
  "nuevo": "popout-module__nuevo___UB_P8",
  "inner": "popout-module__inner___GX_Rh",
  "button": "popout-module__button___OefsF",
  "e": "popout-module__e___SYDQA",
  "w": "popout-module__w___pizzh",
  "resizable": "popout-module__resizable___wMK03",
  "json_button": "popout-module__json_button___sN3d5",
  "headerPadding": "popout-module__headerPadding___BAZRS",
  "footer": "popout-module__footer___qOVuJ"
};
const DEFAULT_WIDTH = 428;
class Popout extends _react.default.PureComponent {
  static propTypes = {
    className: T.string,
    buttonClassName: T.string,
    minWidth: T.number,
    maxWidth: T.number,
    nuevo: T.bool,
    resizable: T.bool,
    initialWidth: T.number,
    titleDisplayId: T.string,
    onCloseClick: T.func.isRequired,
    onResize: T.func,
    hideFooter: T.bool
  };
  static defaultProps = {
    nuevo: false,
    resizable: false,
    hideFooter: false,
    minWidth: DEFAULT_WIDTH,
    maxWidth: window.innerWidth - 100,
    initialWidth: DEFAULT_WIDTH,
    onCloseClick: _constants.NOOP,
    onResize: _constants.NOOP
  };
  state = {
    width: this.props.children?.props.initialWidth || this.props.initialWidth
  };
  setRef(ref) {
    if (this.props.nuevo && this.props.resizable && ref) {
      this.stickoutRef = ref;
      this.stickoutRef.addEventListener('mousedown', this.onMouseDown, false);
    }
  }
  comopnentWillUnmount() {
    if (this.stickoutRef) {
      this.stickoutRef.removeEventListener('mousedown', this.onMouseDown);
      document.removeEventListener('mouseup', this.onMouseUp);
      document.removeEventListener('mousemove', this.onMouseMove);
    }
  }
  onMouseDown = (0, _bind.default)(_context = this.onMouseDown).call(_context, this);
  onMouseDown(e) {
    document.addEventListener('mouseup', this.onMouseUp, false);
    document.addEventListener('mousemove', this.onMouseMove, false);
    e.preventDefault();
    // save mouse X coordinate
    this.dragStartPositionX = e.x;
  }
  onMouseUp = (0, _bind.default)(_context2 = this.onMouseUp).call(_context2, this);
  onMouseUp() {
    document.removeEventListener('mousemove', this.onMouseMove, false);
    document.removeEventListener('mouseup', this.onMouseUp);
  }
  onMouseMove = (0, _bind.default)(_context3 = (0, _throttle.default)(this.onMouseMove, 60)).call(_context3, this);
  onMouseMove(e) {
    const {
      minWidth,
      maxWidth
    } = this.props;
    // `deltaX` is a difference between previous position of the mouse cursor
    // and the current one (dragStartPositionX - dragEndPositionX)
    const deltaX = this.dragStartPositionX - e.x;
    // replace previous mouse X position with the latest one
    this.dragStartPositionX = e.x;
    this.setState(prevState => {
      // make sure the width is within the bounds [minWidth, maxWidth]
      const width = (0, _clamp.default)(prevState.width + deltaX, minWidth, maxWidth);
      return width === prevState.width ? null : {
        width
      };
    }, this.onResize);
  }
  onResize = (0, _bind.default)(_context4 = (0, _debounce.default)(this.onResize, 250)).call(_context4, this);
  onResize() {
    this.props.onResize(this.state.width);
  }
  render() {
    const {
      nuevo,
      resizable,
      className,
      buttonClassName,
      minWidth,
      maxWidth,
      popoutHeader,
      onCloseClick,
      children,
      hideFooter
    } = this.props;
    const {
      width
    } = this.state;
    const style = {};
    if (nuevo) {
      style.width = this.state.width;
      style.minWidth = this.state.width;
    }
    const classNames = (0, _classnames.default)(styles.container, {
      [styles.nuevo]: nuevo,
      [styles.resizable]: resizable
    }, className);
    const stickoutClassNames = (0, _classnames.default)(styles.stickout, {
      [styles.e]: width === maxWidth,
      [styles.w]: width === minWidth
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      style: style,
      className: classNames
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: stickoutClassNames,
      ref: ref => this.setRef(ref)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.inner
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.button, styles[buttonClassName]),
      onClick: onCloseClick
    }), popoutHeader), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.content, {
        [styles.headerPadding]: Boolean(popoutHeader)
      })
    }, children), !hideFooter && /*#__PURE__*/_react.default.createElement(_objects.Footer, {
      className: styles.footer
    }));
  }
}
exports.default = Popout;